module.exports = __webpack_public_path__ + "assets/e161bc11cda9b516462ed915ff102bf5.mp3";